<template>
  <div class="cake">
    <header class="header">
      <steps :active="nowStep" active-color="#ef4c4f">
        <step>选员工</step>
        <step>选蛋糕</step>
        <step>确认配送信息</step>
        <step>提交</step>
      </steps>
    </header>
    <swipe ref="swipeRef" class="my-swipe" :show-indicators="false" :touchable="false">
      <swipe-item class="page">
        <Staff ref="staffRef"></Staff>
      </swipe-item>
      <swipe-item class="page">
        <Cake ref="cakeRef" :orderInfo="orderInfo"></Cake>
      </swipe-item>
      <swipe-item class="page">
        <Conform ref="conformRef" :orderInfo="orderInfo"></Conform>
      </swipe-item>
    </swipe>
    <footer class="footer">
      <div>
        <Button
          v-if="nowStep===0"
          class="history-btn"
          size="small"
          type="default"
          @click="history"
        >历史记录</Button>
      </div>
      <div class="flex-start">
        <template v-if="nowStep!==0">
          <Button class="btn" block type="default" size="small" round @click="back">上一步</Button>
        </template>
        <template v-if="nowStep!==2">
          <Button class="btn" block type="default" size="small" round @click="next">下一步</Button>
        </template>
        <template v-else>
          <Button class="btn" block type="danger" size="small" round @click="submit">提交</Button>
        </template>
      </div>
    </footer>
  </div>
</template>

<script>
import { Step, Steps, Swipe, SwipeItem, Button, Dialog } from 'vant';
import Staff from './components/staff';
import Cake from './components/cake';
import Conform from './components/conform';
import { createCakeOrder } from '@/api/birthday';
import { formatDate } from '@utils/date.js'

export default {
  components: {
    Steps,
    Step,
    Swipe,
    SwipeItem,
    Button,
    Staff,
    Cake,
    Conform,
  },

  data() {
    return {
      nowStep: 0,
      orderInfo: {
        staff: null, // 员工信息
        cake: null, // 蛋糕信息
      },
    };
  },

  methods: {

    /**
     * 下一步
     */
    next() {
      if (this.nowStep === 0) { // 步骤一
        const _staff = this.$refs.staffRef.nextCheck();
        if (!_staff) {
          this.$toast('请选择员工');
          return;
        }
        this.orderInfo.staff = _staff;
        // 初始化步骤二蛋糕信息
        this.$refs.cakeRef.init();
      }

      if (this.nowStep === 1) { // 步骤二
        const _cake = this.$refs.cakeRef.nextCheck();
        if (!_cake) {
          this.$toast('请选择蛋糕');
          return;
        }
        this.orderInfo.cake = _cake;
        //
        this.$refs.conformRef.init();
      }
      // this.$refs.staffRef.nextCheck();
      ++this.nowStep;
      this.$refs.swipeRef.next();
    },

    /**
     * 上一步
     */
    back() {
      if (this.nowStep === 0) return;
      --this.nowStep;
      this.$refs.swipeRef.prev();
    },

    /**
     * 提交预约信息
     */
    submit() {
      const _from = this.$refs.conformRef.canSubmit();
      if (!_from) return;

      const _deliveryDate = new Date(_from.deliveryTime)
      _deliveryDate.setDate(_deliveryDate.getDate() - 1)

      Dialog.confirm({
        title: '是否确认提交订单',
        message: `下单后如需取消本单，请在${formatDate(_deliveryDate,'MM月dd日')} 11:00前完成取消。为避免订单遗漏，如需再次下单，请尽快完成新订单`,
      }).then(() => {
        const params = {
          cakeId: this.orderInfo.cake.id,
          cakeName: this.orderInfo.cake.commodityName,
          cakeSpecs: this.orderInfo.cake.cakeSizeCode,
          detailIds: this.orderInfo.staff.map(staff => staff.id),
          jobMarketId: _from.jobMarketId,
          contactsAddress: _from.contactsAddress,
          contactsName: _from.contactsName,
          contactsPhone: _from.contactsPhone,
          deliveryTime: _from.deliveryTime,
        };
        createCakeOrder(params).then(res => {
          this.$toast('订单创建成功');
          this.history();
        }).catch(({ message = '系统异常' }) => {
          this.$toast(message);
        });
      });
    },

    history() {
      this.$router.push('/birthday/list');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
<style lang="scss">
.cake .van-step--horizontal .van-step__title {
  font-size: 14px;
}
</style>